var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.501 3.19336C12.9498 3.19336 12.4459 3.50478 12.1994 3.9978L11.1463 6.10384H6.22477C5.42106 6.10384 4.76953 6.75537 4.76953 7.55907C4.76953 8.36278 5.42106 9.01431 6.22477 9.01431L6.22477 23.5667C6.22477 25.1741 7.52783 26.4772 9.13525 26.4772H20.7772C22.3846 26.4772 23.6876 25.1741 23.6876 23.5667V9.01431C24.4913 9.01431 25.1429 8.36278 25.1429 7.55907C25.1429 6.75537 24.4913 6.10384 23.6876 6.10384H18.7661L17.713 3.9978C17.4665 3.50478 16.9626 3.19336 16.4114 3.19336H13.501ZM10.5905 11.9248C10.5905 11.1211 11.242 10.4696 12.0457 10.4696C12.8494 10.4696 13.501 11.1211 13.501 11.9248V20.6562C13.501 21.4599 12.8494 22.1115 12.0457 22.1115C11.242 22.1115 10.5905 21.4599 10.5905 20.6562V11.9248ZM17.8667 10.4696C17.063 10.4696 16.4114 11.1211 16.4114 11.9248V20.6562C16.4114 21.4599 17.063 22.1115 17.8667 22.1115C18.6704 22.1115 19.3219 21.4599 19.3219 20.6562V11.9248C19.3219 11.1211 18.6704 10.4696 17.8667 10.4696Z",
    fill: "#F31260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBtnIcon);
export default __webpack_public_path__ + "static/media/delete-btn-icon.7f86396474c5f344a59161d97cfe3618.svg";
export { ForwardRef as ReactComponent };